import React, { useEffect, useMemo } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import DetailRow from "../CustomComponents/DetailRow";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import ZoomImage from "../ZoomImage";
import CustomLoader from "../CustomComponents/CustomLoader";

const VehicleDetailModal = ({
  handleModalClose,
  data,
  reviewData,
  isReviewFetching,
}) => {
  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const detailItems = useMemo(
    () => [
      { title: "Name", value: data?.name },
      { title: "Model", value: data?.model },
      { title: "Color", value: data?.color },
      { title: "Car Type", value: data?.car_type },
      { title: "Engine Capacity", value: data?.engine_capacity },
      { title: "Rental Type", value: data?.rental_type },
      { title: "Rental Price", value: `$ ${data?.rental_price}` },
      { title: "Average Ratings", value: data?.average_ratings },
    ],
    [data]
  );

  if (!mounted) {
    return null;
  }

  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">More Details</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>

          <div className="w-100">
            <DetailRow title={"Description"} />
            <p className="text-black ">{data?.description}</p>
            <hr className="w-100" />

            <Row className="text-black g-5">
              <Col sm={12} md={6}>
                <h6 className="gray-text mb-4">Additional Detail:</h6>
                {detailItems.map(
                  (item, index) =>
                    item && (
                      <DetailRow
                        key={index}
                        title={item.title}
                        value={item.value}
                      />
                    )
                )}
              </Col>
              <Col sm={12} md={6}>
                <h6 className="gray-text mb-4">Gallery:</h6>
                <div className="d-flex flex-wrap gap-2">
                  {data?.attachments.map((attach, index) => (
                    <ZoomImage key={index} imageUrl={attach.media_url} />
                  ))}
                </div>
              </Col>
            </Row>
          </div>
          <hr className="w-100" />
          <div className="w-100">
            <DetailRow title={"Reviews"} />
            {true ? <Spinner /> : ""}
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default VehicleDetailModal;
